import { Form, Select } from "antd";

import { useOpportunityStates } from "../../data/use-opportunity-states";
import { filterOption } from "./filter-option";
import { pickFormItemProps, pickSelectProps } from "./pick-props";
import { getSelectOptions } from "../../utils/get-select-options";

export const OpportunityStateSelect = (props) => {
  const opportunityStates = useOpportunityStates();

  const form = Form.useFormInstance();
  const initialValue = form.getFieldValue(props.name);

  return (
    <Form.Item {...pickFormItemProps(props)}>
      <Select
        showSearch
        optionFilterProp="children"
        filterOption={filterOption}
        options={getSelectOptions({
          store: opportunityStates,
          initialIds: initialValue,
          labelKey: "label",
          sortAlphabetical: false,
        })}
        {...pickSelectProps(props)}
      />
    </Form.Item>
  );
};
